import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, IconButton, TextField, MenuItem
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import api from '../../../api/axiosInterceptor';
import { API_BASE_URL } from '../../../config';
import TableComponent from '../../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../../Components/spinner/spinner';

export const AdminSherastedarComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const [feBaseList, setFeBaseList] = useState([]);
  const [userList, setUserList] = useState([]);

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [formData, setFormData] = useState({
    financial_establishment: '',
    shirastedar: '',
    is_active: true,
  });
  const [formErrors, setFormErrors] = useState({});
  const [userSearch, setUserSearch] = useState('');

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
    {
      id: 'financial_establishment',
      field: 'financial_establishment',
      headerName: 'FE Base',
      width: 200,
      renderCell: (params) => {
        const feBase = feBaseList.find(fe => fe.id === params.value);
        return feBase ? feBase.name_of_fe : 'N/A';
      },
    },
    {
      id: 'shirastedar',
      field: 'shirastedar',
      headerName: 'Sherastedar Email',
      width: 230,
      renderCell: (params) => {
        const user = userList.find(user => user.id === params.value);
        return user ? user.email : 'N/A';
      },
    },
    {
      id: 'is_active',
      field: 'is_active',
      headerName: 'Active',
      width: 80,
      renderCell: (params) => (params.value ? 'Yes' : 'No'),
    },
    {
      id: 'actions',
      field: 'actions',
      headerName: 'Actions',
      width: 120,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={loading}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={loading}>
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  // const fetchFeSuperStaffList = () => {
  //   setLoading(true);
  //   api.get(`${API_BASE_URL}/fe-mgmt/fe-shirastedar/`)
  //     .then(res => {
  //       const data = res.data.map((item, index) => ({
  //         id: item.id,
  //         slNo: index + 1,
  //         ...item,
  //       }));
  //       setRows(data);
  //       setLoading(false);
  //     })
  //     .catch(() => {
  //       setSnackbarMessage('Failed to fetch shirastedar records.');
  //       setSnackbarSeverity('error');
  //       setSnackbarOpen(true);
  //       setLoading(false);
  //     });
  // };


  const fetchFeSuperStaffList = async () => {
  setLoading(true);
  try {
    const [ver2Res, feBaseRes, userRes] = await Promise.all([
      api.get(`/fe-mgmt/fe-shirastedar/`),
      api.get(`/fe-mgmt/fe-base/`),
      api.get(`/auth/role-mgmt/`)
    ]);

    const feBaseMap = new Map(feBaseRes.data.map(fe => [fe.id, fe.name_of_fe]));
    const userMap = new Map(userRes.data.map(u => [u.id, u.email]));

    const enrichedRows = ver2Res.data.map((item, index) => ({
      id: item.id,
      slNo: index + 1,
      financial_establishment: item.financial_establishment,
      shirastedar: item.shirastedar,
      is_active: item.is_active,
      fe_base_name: feBaseMap.get(item.financial_establishment) || 'N/A',
      ver2_email: userMap.get(item.shirastedar) || 'N/A'
    }));

    setFeBaseList(feBaseRes.data);
    setUserList(userRes.data);
    setRows(enrichedRows);
  } catch (error) {
    setSnackbarMessage('Failed to fetch shirastedar or related data.');
    setSnackbarSeverity('error');
    setSnackbarOpen(true);
  } finally {
    setLoading(false);
  }
};


  const fetchFeBaseList = () => {
    api.get(`/fe-mgmt/fe-base/`)
      .then(res => setFeBaseList(res.data || []))
      .catch(() => setFeBaseList([]));
  };

  const fetchUserList = () => {
    api.get(`/auth/role-mgmt/`)
      .then(res => setUserList(res.data || []))
      .catch(() => setUserList([]));
  };

  useEffect(() => {
    fetchFeSuperStaffList();
    fetchFeBaseList();
    fetchUserList();
  }, []);

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleAdd = () => {
    setIsEditMode(false);
    setFormData({ financial_establishment: '', shirastedar: '', is_active: true });
    setFormErrors({});
    setUserSearch('');
    setOpenFormDialog(true);
  };

  const handleEdit = (item) => {
    setIsEditMode(true);
    setSelectedItem(item);
    setFormData({
      financial_establishment: item.financial_establishment || '',
      shirastedar: item.shirastedar || '',
      is_active: !!item.is_active,
    });
    setFormErrors({});
    setUserSearch('');
    setOpenFormDialog(true);
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.financial_establishment) errors.financial_establishment = 'FE Base is required';
    if (!formData.shirastedar) errors.shirastedar = 'Verifier 2 is required';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
      if (isEditMode) {
        await api.patch(`/fe-mgmt/fe-shirastedar/${selectedItem.id}/`, formData);
        setSnackbarMessage('shirastedar record updated successfully.');
      } else {
        await api.post(`/fe-mgmt/fe-shirastedar/`, formData);
        setSnackbarMessage('shirastedar record created successfully.');
      }
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      fetchFeSuperStaffList();
      setOpenFormDialog(false);
    } catch {
      setSnackbarMessage('Failed to save shirastedar record.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const handleDeleteConfirmation = (item) => {
    setDeleteItem(item);
    setDeleteDialogOpen(true);
  };

  const handleDelete = async () => {
    try {
      await api.delete(`/fe-mgmt/fe-shirastedar/${deleteItem.id}/`);
      setSnackbarMessage('shirastedar record deleted successfully.');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      fetchFeSuperStaffList();
    } catch {
      setSnackbarMessage('Failed to delete record.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setDeleteDialogOpen(false);
    }
  };

  const filteredUsers = userList.filter(u =>
    u.email && u.email.toLowerCase().includes(userSearch.toLowerCase())
  );

  if (loading) return <LoadingSpinner size={30} />;

  return (
    <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', bgcolor: '#fff' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(255,228,196,0.1)" p={2}>
        <Typography variant="h4" fontWeight="bold">shirastedar Master</Typography>
        <Button variant="contained" color="primary" onClick={handleAdd}>Add New Shirastedar</Button>
      </Box>

      <TableComponent columns={columns} rows={rows} manageColumnStatus enableSort sx={{
        '& .MuiDataGrid-columnHeaders': { backgroundColor: '#ff8c00', color: '#fff', fontWeight: 'bold' }
      }} />

      <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{isEditMode ? 'Edit shirastedar Record' : 'Add shirastedar Record'}</DialogTitle>
        <DialogContent>
          <TextField
            select
            label="FE Base"
            margin="normal"
            fullWidth
            value={formData.financial_establishment}
            onChange={e => setFormData({ ...formData, financial_establishment: e.target.value })}
            error={!!formErrors.financial_establishment}
            helperText={formErrors.financial_establishment}
          >
            {feBaseList.map(fe => (
              <MenuItem key={fe.id} value={fe.id}>{fe.name_of_fe}</MenuItem>
            ))}
          </TextField>

          <TextField
            label="Search Verifier 2 by Email"
            margin="normal"
            fullWidth
            value={userSearch}
            onChange={e => setUserSearch(e.target.value)}
            placeholder="Type to search Verifier 2 email..."
          />

          <TextField
            select
            label="Assign Verifier 2 (Email)"
            margin="normal"
            fullWidth
            value={formData.shirastedar}
            onChange={e => setFormData({ ...formData, shirastedar: e.target.value })}
            error={!!formErrors.shirastedar}
            helperText={formErrors.shirastedar}
          >
            {filteredUsers.length ? (
              filteredUsers.map(user => (
                <MenuItem key={user.id} value={user.id}>{user.email}</MenuItem>
              ))
            ) : (
              <MenuItem disabled>No matching users</MenuItem>
            )}
          </TextField>

          <TextField
            select
            label="Active"
            margin="normal"
            fullWidth
            value={formData.is_active ? 'true' : 'false'}
            onChange={e => setFormData({ ...formData, is_active: e.target.value === 'true' })}
          >
            <MenuItem value="true">Active</MenuItem>
            <MenuItem value="false">Inactive</MenuItem>
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenFormDialog(false)}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            {isEditMode ? 'Update' : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>Are you sure you want to delete this super Staff permission?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleDelete} color="error" variant="contained">Delete</Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
    </Box>
  );
};
